import {WorldModel} from "./worldCountry.model";

export const checkCountryCodeListIncludeSearchString = (array: WorldModel[], searchText: string): WorldModel[] => {
  if (array) {
    const list: WorldModel[] = [];
    array.forEach((world) => {
      if (world.Name.toString().includes(searchText)) {
        list.push(world);
      }else if (world.Tel.toString().includes(searchText)) {
        list.push(world);
      }
      return '';
    });
    return list;
  }
  return [];
};
